export default __webpack_public_path__ + "static/media/E19.86eb24e2.jpg";